export { ModalProps, Modal } from "./Modal";
